// @flow
import parseLatLng from 'mz-utils/parseLatLng'
import type { Location } from '../../../models/location'
import type { SuggestionLocation } from '../../../api_types'

/**
 * By given search location object create unified location object
 * @param  {SearchLocation} searchLocation
 * @return {Location}
 */
function buildSuggestionLocation(loc: SuggestionLocation): Location {
  return {
    name: loc.name || loc.value || '',
    customName: loc.display || '',
    address: loc.value || '', // important for `getMaximizedLocation`
    fullAddress: loc.value || '',
    iataCode:
      loc.type === 'airport' || loc.type === 'train_station'
        ? loc.value || ''
        : '',
    country: '',
    notSpecific: false,
    timezone: '',
    placeId: loc.place_id || '',
    trainStationName: (loc.type === 'train_station' ? loc.name : '') || '',
    airportName: (loc.type === 'airport' ? loc.name : '') || '',
    isCruisePort: loc.type === 'port',
    isTrainStation: loc.type === 'train_station',
    type: loc.type || '',
    favoriteId: loc.favorite_id,
    favoriteSource: loc.favorite_source,
    ...parseLatLng(loc.lat, loc.lng),
  }
}

export default buildSuggestionLocation
